import React from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../components/Footer";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.acha.BLEEP";

const Verify = ({ domain }) => {
  return (
    <>
      <Helmet>
        <title>Verify | BLEEP</title>
      </Helmet>

      <div
        className="verify-wrap"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          background: "#0b0b0b",
        }}
      >
        <div
          className="verify-card"
          style={{
            maxWidth: 680,
            width: "100%",
            borderRadius: 16,
            padding: "28px 24px",
            background:
              "linear-gradient(180deg, rgba(231,79,3,0.12) 0%, rgba(231,79,3,0.05) 100%)",
            border: "1px solid rgba(231,79,3,0.35)",
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: 28,
              lineHeight: 1.2,
              color: "#fff",
              fontWeight: 800,
              letterSpacing: 0.2,
            }}
          >
            Verify with the BLEEP app
          </h1>

          <p
            style={{
              marginTop: 12,
              marginBottom: 20,
              color: "rgba(255,255,255,0.85)",
              fontSize: 16,
              lineHeight: 1.6,
            }}
          >
            To access this service, please download the latest version of the
            BLEEP app. Once installed, open the BLEEP app and tap the{" "}
            <strong>Verify</strong> button to scan & verify items with a Bleep
            Security Tag.
          </p>

          {/* Badges row */}
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {/* Google Play badge (active) */}
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
              style={{ display: "inline-block", textDecoration: "none" }}
            >
              <img
                src="/images/getitongoogleplaybadge.png"
                alt="Get it on Google Play"
                style={{
                  height: 56,
                  width: "auto",
                  display: "block",
                  filter: "drop-shadow(0 4px 20px rgba(0,0,0,0.35))",
                }}
              />
            </a>

            {/* App Store badge (disabled but displayed) */}
            <span
              aria-disabled="true"
              title="Coming soon on iOS"
              style={{
                position: "relative",
                display: "inline-block",
                pointerEvents: "none",
                opacity: 0.6,
                filter: "grayscale(100%)",
              }}
            >
              <img
                src="/images/appstore_btn.png"
                alt="Download on the App Store (coming soon)"
                style={{
                  height: 56,
                  width: "auto",
                  display: "block",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  right: 6,
                  bottom: 6,
                  fontSize: 10,
                  padding: "2px 6px",
                  borderRadius: 999,
                  background: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  letterSpacing: 0.3,
                }}
              >
                Coming soon
              </span>
            </span>
          </div>

          <div
            style={{
              marginTop: 20,
              fontSize: 13,
              color: "rgba(255,255,255,0.65)",
            }}
          >
            <p style={{ margin: 0 }}>
              Already installed? Make sure you have the latest version of the
              app to access this feature.
            </p>
          </div>
        </div>
      </div>
      <Footer domain={domain} />
    </>
  );
};

export default Verify;
